const globalStyles = {
  colors: {
    backgroundPrimary: '#2b3f7a !important',
    backgroundSecondary: '#3e5aaf',
    sideNavColor: '#314789',
    white: '#FFF',
    black: '#000',
    lightGrey: '#ECECEC',
    smokeGrey: '#778899'
  },
  fonts: {

  },
  common: {
    // headingSize: '1.2rem',
    headingSize: '1.4rem',
    infoTablesPadding: '8px 5px'
  },
  createButton: {
    float: 'right',
    backgroundColor: '#2b3f7a',
    textTransform: 'capitalize',
    borderRadius: '25px',
    padding: '10px 30px',
    lineHeight: 'unset !important',
    height: '40px',
  },
  headerWrapperBox: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    backgroundColor: '#f7f7f7'
  },
  headerCountSubtitle: {
    padding: '20px 0px 0px 5px',
    lineHeight: 1,
    fontSize: '0.9rem',
    color: '#000'
  },
  datagridList: {
    margin: '0px 30px !important',
    width: '95%'
  },
  listSubheaderIcons: {
    textTransform: 'capitalize',
    color: '#2b3f7a',
    fontSize: '14px',
    borderRadius: '0px',
    '& .MuiSvgIcon-root': {
      width: '30px',
      height: '30px'
    }
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    height: '189px',
    p: 4,
  },
  remarkModalContainer: {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh',
  overflowY: 'auto'
},
  loginComponentContainer: {
    height: '100vh',
    width: '100vw',
    margin: '0 !important',
    padding: '0 !important'
  },
  bottomNavigationMenu: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    padding: '10px 10px',
    backgroundColor: 'transparent',
    marginRight: '5%',
    '& .MuiBottomNavigationAction-root': {
      'border-top-left-radius': '18px',
      'border-top-right-radius': '18px',
      'border-bottom-right-radius': '18px',
      'border-bottom-left-radius': '18px',
      backgroundColor: '#2b3f7a!important',
      color: '#fff !important',
      margin: '2px 10px !important',
      padding: '0 !important',
      fontSize: '0.9rem !important',
      // '&:hover': {
      //   transform: 'scale(1.1, 1.1)'
      // },
      // '& .Mui-selected': {
      //   color: '#fff',
      //   transition: 'none',
      //   fontSize: '0.9rem'
      // }
    }
  },
  bottomNavigationMenuNew: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    padding: '10px 5px',
    marginLeft: '38.8%',
    marginTop: '-50px',
    marginRight: '10%',
    '& .MuiBottomNavigationAction-root': {
      'border-top-left-radius': '25px',
      'border-top-right-radius': '25px',
      margin: '-2px 10px !important',
      padding: '0 !important',
      fontSize: '0.9rem !important',
    }
  },

  shippingOptionsButton: {
    display: 'block',
    backgroundColor: '#2b3f7a !important',
    color: '#fff',
    padding: '10px',
    borderRadius: 0,
    margin: '10px 0px 10px',
    textTransform: 'capitalize'
  },
  reusableButton: {
    backgroundColor: '#2b3f7a !important',
    color: '#fff !important',
    padding: '10px',
    borderRadius: 0,
    textTransform: 'capitalize'
  },
  reusableButtonLight: {
    backgroundColor: '#fff',
    color: '#2b3f7a',
    border: '2px solid #2b3f7a',
    padding: '10px',
    borderRadius: 0,
    textTransform: 'capitalize'
  }
  ,
  bottomNavigationExport: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 10px",
    marginRight: "5%",
    '& .MuiBottomNavigationAction-root': {
      backgroundColor: '#2b3f7a!important',
      color: '#fff !important',
      paddingRight: '50px !important',
      paddingLeft: '50px !important',
    }
  }
  , exportLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  customSelect: {
    position: 'relative',
    display: 'inline-block',
    width: '250px',
  },

  customSelect2: {
    position: 'relative',
    display: 'inline-block',
    width: '150px',
    fontWeight: '500',
    fontSize: '12px',
  }
}



export default globalStyles